export const TID = {
    // header
    logo: "header-logo",
    navHome: "nav-home",
    navMasalas: "nav-masalas",
    navDecor: "nav-decor",
    navJewelry: "nav-jewelry",
    navChristmas: "nav-christmas",
    navShop: "nav-shop",
    navAdmin: "nav-admin",
    navAccount: "nav-account",
    navLogin: "nav-login",
    navLogout: "nav-logout",
    navRegister: "nav-register",
    navCart: "nav-cart",
    langBtn: "lang-switcher-btn",
    langOption: (code) => `lang-option-${code}`,
    // home
    heroCta: "hero-cta-shop",
    heroCta2: "hero-cta-story",
    verticalMasalas: "vertical-card-masalas",
    verticalDecor: "vertical-card-decor",
    verticalJewelry: "vertical-card-jewelry",
    verticalChristmas: "vertical-card-christmas",
    aboutSection: "home-about-section",
    aboutCta: "home-about-cta",
    categorySection: (v) => `home-category-${v}`,
    testimonialsSection: "home-testimonials-section",
    // product card
    productCard: (slug) => `product-card-${slug}`,
    addToCart: (slug) => `add-to-cart-${slug}`,
    // product detail
    pdAddCart: "pd-add-cart",
    pdBuyNow: "pd-buy-now",
    pdQty: "pd-qty",
    pdB2b: "pd-b2b-btn",
    b2bName: "b2b-name",
    b2bPhone: "b2b-phone",
    b2bQty: "b2b-qty",
    b2bEmail: "b2b-email",
    b2bMessage: "b2b-message",
    b2bSubmit: "b2b-submit",
    // shop filters
    filterAll: "filter-all",
    filterMasalas: "filter-masalas",
    filterDecor: "filter-decor",
    filterJewelry: "filter-jewelry",
    filterChristmas: "filter-christmas",
    // cart
    cartCheckout: "cart-checkout",
    cartClear: "cart-clear",
    cartGiftWrap: "cart-giftwrap-toggle",
    cartGiftMessage: "cart-giftwrap-message",
    cartRemove: (slug) => `cart-remove-${slug}`,
    cartQty: (slug) => `cart-qty-${slug}`,
    // christmas
    xmasShopCta: "xmas-shop-cta",
    xmasHero: "xmas-hero",
    // auth
    loginEmail: "login-email",
    loginPassword: "login-password",
    loginSubmit: "login-submit",
    registerEmail: "register-email",
    registerPassword: "register-password",
    registerName: "register-name",
    registerSubmit: "register-submit",
    // admin
    adminStat: (k) => `admin-stat-${k}`,
    adminTabProducts: "admin-tab-products",
    adminTabOrders: "admin-tab-orders",
    adminTabUsers: "admin-tab-users",
};
